import { baseModel } from '../model'
import { ISearchValue, SearchTypeEnum } from '@/components/YhPageHeader/Types'
import { YhPageHeader } from '@/components/YhPageHeader'

export function PageHeader() {
    const { searchParam, updateSearchParam, resetSearchParam, loadData, meetingTypeList } = baseModel()

    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            placeholder: '内容',
            fieldName: 'content',
            span: 3,
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: '类型',
            fieldName: 'meetingType',
            options: meetingTypeList.map((item) => ({ label: item, value: item })),
            span: 3,
        },
    ]

    return (
        <YhPageHeader
            title=""
            size="small"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    )
}
